import React from "react";
import "./Footer.css";

import githubIcon from "../../assets/github-icon.svg";
import xTwitterIcon from "../../assets/x-icon.svg";
export default function Footer() {
  return (
    <footer className="mp-footer py-3">
      <div className="d-flex container">
        <div className="d-flex" style={{ gap: "12px" }}>
          <a
            className="footer-link"
            href="https://docs.moneyprotocol.co" // Replace with your actual GitHub URL
            target="_blank"
            rel="noopener noreferrer"
          >
            Docs
          </a>

          <a
            className="footer-link"
            href="https://github.com/moneyprotocol" // Replace with your actual GitHub URL
            target="_blank"
            rel="noopener noreferrer"
          >
            Github
          </a>

          <a className="footer-link" href="/faq">
            FAQ
          </a>

          <a
            className="footer-link"
            href="https://blog.moneyprotocol.co/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Blog
          </a>

          <a
            className="footer-link"
            href="https://blog.moneyprotocol.co/rss.xml"
            target="_blank"
            rel="noopener noreferrer"
          >
            RSS
          </a>
        </div>
        <div className="d-flex ml-auto" style={{ gap: "12px" }}>
          <a
            className="footer-link"
            href="https://x.com/money_protocol" // Replace with your actual GitHub URL
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={xTwitterIcon} alt="GitHub" className="img-fluid" />
          </a>

          <a
            className="footer-link"
            href="https://github.com/moneyprotocol" // Replace with your actual GitHub URL
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={githubIcon} alt="GitHub" className="img-fluid" />
          </a>
        </div>
      </div>
    </footer>
  );
}
